import { ConnectionTypes } from 'config/constants'

const getConnectionTypeName = type => {
  const configKey = type === 'e2' ? 'idrivee2' : type

  if (Object.prototype.hasOwnProperty.call(ConnectionTypes, configKey)) {
    const config = ConnectionTypes[configKey]
    return config.displayName ?? config.name
  }

  return type
}

export const formatDeviceConnections = connectionStats =>
  (connectionStats ?? []).map(({ connectionType, configuredCount, connectedCount }) => ({
    type: connectionType,
    text: `${getConnectionTypeName(connectionType)}: ${connectedCount} of ${configuredCount} connected`,
  }))
